// feature/eva-litisoft — Eva's identity mark. Athena-native: a rounded-square
// badge in the mint accent with a small owl-eye motif (nods to the Athena owl
// without copying it). Pure inline SVG, theme-aware via tokens. `size` in px.
import React from "react";

export default function EvaMark({ size = 28, title = "Eva" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" role="img" aria-label={title}
         style={{ flexShrink: 0, display: "block" }}>
      <rect x="1" y="1" width="30" height="30" rx="9"
            fill="var(--accent-mint)" />
      <rect x="1" y="1" width="30" height="30" rx="9"
            fill="none" stroke="var(--accent-ink)" strokeOpacity="0.25" />
      {/* two eyes — calm, attentive */}
      <circle cx="12" cy="14" r="3.4" fill="var(--on-accent)" />
      <circle cx="20" cy="14" r="3.4" fill="var(--on-accent)" />
      <circle cx="12.6" cy="14.4" r="1.5" fill="var(--accent-mint)" />
      <circle cx="20.6" cy="14.4" r="1.5" fill="var(--accent-mint)" />
      {/* soft beak / smile */}
      <path d="M14 21 Q16 23 18 21" fill="none" stroke="var(--on-accent)"
            strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}
